import { useMutation } from '@tanstack/react-query'
import { useAuthStore } from '../../../zustand/authentication/use-auth-store'
import api from '../../config/axios-config'
import { setupNotifications } from '../../../containers/authentication/utils/setup-notifications'
import { authMutationKeys } from '../constants'

export const useLoginGetUserMutation = () => {
  const { setPasswordPolicy, logout } = useAuthStore()

  const handleTwoFactor = async (email) => {
    const config = {
      method: 'get',
      params: {
        email
      },
      headers: null
    }

    const { data } = await api('/api/twoFactor', config)
    return data
  }

  const handleMutation = async ({ data: user }) => {
    try {
      if (!user) throw new Error()

      if (user.email) {
        const data2fa = await handleTwoFactor(user.email)
        setPasswordPolicy(data2fa)
      }

      setupNotifications()
    } catch (error) {
      if (error.response?.status === 401) {
        logout()
        throw error
      }
      throw error
    }
  }

  return useMutation({
    mutationFn: (credentials) => handleMutation(credentials),
    mutationKey: authMutationKeys.LOGGED_USER
  })
}
